// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_YkXxY","shadow":"_36reT","backgroundFrame":"_3QtUN","content":"_3F8SV"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Modal/Modal.scss
// module id = 907
// module chunks = 9